module.exports = __webpack_public_path__ + "img/8.f03231c5.jpg";